/* eslint jsx-a11y/label-has-associated-control:0 */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon from '../Icon';

const triggerOnLastTransition = onCloseFn => e => {
  if (e.nativeEvent.propertyName === 'top') return;

  if (onCloseFn) onCloseFn();
};

const Alert = ({
  alertType,
  children,
  className,
  onClose,
  showCloseButton,

  contentWrapperProps,
  iconLabelProps,
  iconProps,
  iconWrapperProps,
  inputProps,
  wrapperProps
}) => (
  <div
    style={{ position: 'relative', top: '-4px' }}
    className={className}
    {...wrapperProps}
  >
    {showCloseButton && (
      <Fragment>
        {/* id='Alert_Close' is needed because it is styled as an ID */}
        <input
          {...inputProps}
          type='checkbox'
          id='Alert_Close'
          className='sr-only'
        />
        <div
          {...iconWrapperProps}
          className={classnames('alert__close', `alert--${alertType}`)}
        >
          <label htmlFor='Alert_Close' {...iconLabelProps}>
            <Icon variant='close-cross' {...iconProps} />
          </label>
        </div>
      </Fragment>
    )}
    <div
      {...contentWrapperProps}
      className={classnames('alert', `alert--${alertType}`)}
      onTransitionEnd={triggerOnLastTransition(onClose)}
    >
      {children}
    </div>
  </div>
);

Alert.defaultProps = {
  alertType: 'error',
  showCloseButton: true
};

Alert.propTypes = {
  alertType: PropTypes.oneOf(['info', 'error', 'success']),
  children: PropTypes.node,
  className: PropTypes.string,
  onClose: PropTypes.func,
  showCloseButton: PropTypes.bool,

  contentWrapperProps: PropTypes.object,
  iconLabelProps: PropTypes.object,
  iconProps: PropTypes.object,
  iconWrapperProps: PropTypes.object,
  inputProps: PropTypes.object,
  wrapperProps: PropTypes.object
};

export default Alert;
